import { Axios } from 'helper/Axios';

// backend default hanya 10 room, ambil 50 supaya chat lama tetap terlihat
export const getListCHat = async (search = '') => {
  try {
    const URL = 'chat?' + new URLSearchParams({ page: 1, limit: 50, search });
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getListCHatHistory = async (search = '') => {
  try {
    const URL =
      '/chat/history?' + new URLSearchParams({ page: 1, limit: 50, search });
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getTakeOver = async (idRoom) => {
  try {
    const URL = `chat/take-over/${idRoom}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getEndChat = async (idRoom) => {
  try {
    const URL = `chat/finish/${idRoom}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getListPenawaran = async (filter) => {
  try {
    const URL = `offer/chat?${filter}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getDetailListPenawaran = async (offerId) => {
  try {
    const URL = `offer/${offerId}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getListHargaKhusus = async (filter) => {
  try {
    const URL = `special-price?${filter}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const getDetailListHargaKhusus = async (couponId) => {
  try {
    const URL = `special-price/${couponId}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const readChat = async (idChatRoom) => {
  try {
    const URL = `chat/read-chat/${idChatRoom}`;
    const response = await Axios.get(URL);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

export const regiterToken = async (payload) => {
  try {
    const URL = '/register-fcm-token';
    const response = await Axios.post(URL, payload);
    return response.data;
  } catch (error) {
    // console.log(error);
  }
};

// harus sama dengan constant.ChatRoomInactiveMinutes di backend
export const CHAT_AUTO_END_MINUTES = 60;

// status room untuk badge di list & header chat
export const getChatStatus = (room) => {
  if (room?.is_finish_flag === 'Y') {
    return { label: 'Selesai', className: 'text-neutral-600 bg-neutral-100' };
  }
  if (!room?.user_id_admin) {
    return {
      label: 'Menunggu Take Over',
      className: 'text-amber-700 bg-amber-50',
    };
  }
  return { label: 'Aktif', className: 'text-green-700 bg-green-50' };
};

// lawan bicara admin: surveyor atau petani
export const getChatRole = (room) =>
  room?.user_id_surveyor ? 'Surveyor' : 'Petani';
